// Asset
export const asset = `asset->{url}`

// Link ref
export const linkRef = `linkReference->{title, slug}`

// Rich text editor
export const textEditor = `..., markDefs[]{..., _type == "internalLink" => {"slug": @.reference->slug, "type": @.reference->type, "author": @.reference->author}}, _type == "image" => {..., ${asset}}`

// Button
export const button = `..., ${linkRef}`

// FAQ posts
export const groqFaqPosts = `{..., answer[]{${textEditor}}}`

// Nav item object
export const navItem = `..., linkReference->{title, slug, icon, type}`

// Banner sidebar object
export const bannerSidebar = `bannerSidebar{..., content[]{${textEditor}}, button{${button}}}`

// Product listing common fields
export const productListing = `content[]{${textEditor}}, banner{..., content[]{${textEditor}}}, ${bannerSidebar}, subCategories{categories[]->{..., parent->{slug}}}`

// SEO fields
export const seo = `seo{..., shareImage{..., ${asset}}, redirect{..., page->{slug, title}}}`
